const adjectives = [
  'gentle', 'kind', 'warm', 'caring', 'loving', 'peaceful', 'bright', 'joyful',
  'hopeful', 'sweet', 'tender', 'soft', 'radiant', 'golden', 'serene', 'calm',
  'cheerful', 'happy', 'blissful', 'graceful', 'pure', 'wise', 'humble', 'brave'
];

const animals = [
  'panda', 'butterfly', 'dove', 'rabbit', 'dolphin', 'swan', 'deer', 'owl',
  'fox', 'cat', 'puppy', 'lamb', 'bird', 'whale', 'turtle', 'bear', 'lion',
  'tiger', 'elephant', 'koala', 'penguin', 'seal', 'otter', 'hedgehog'
];

export const generateKindnessId = () => {
  const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const animal = animals[Math.floor(Math.random() * animals.length)];
  const number = Math.floor(Math.random() * 9999) + 1000;
  
  return `${adjective}-${animal}-${number}`;
};